// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuzcuEocCTrTW9 {
  position: relative;
}
.SFKFOAVx5TzdRK {
  margin-bottom: var(--ds-space-050, 4px);
  font-size: 20px;
  font-weight: var(--ds-font-weight-bold, bold);
  line-height: 24px;
}
.pci3Xfv_JHx2jD {
  margin-bottom: var(--ds-space-250, 21px);
  font-size: 14px;
  line-height: 20px;
}
.pneW2Kz3W0r2oP {
  display: flex;
  align-items: center;
  gap: var(--ds-space-075, 6px);
  margin-bottom: var(--ds-space-250, 20px);
}
.pneW2Kz3W0r2oP .Qzl0gP_ruLmaNF {
  color: var(--ds-background-information-bold, #0c66e4);
}
.pneW2Kz3W0r2oP .uStp1YEsXZIK3C {
  margin-bottom: var(--ds-space-0, 0);
  font-size: 12px;
  line-height: 16px;
}
.kzlfYv7QCUMtkQ {
  position: absolute;
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
}
`, ""]);
// Exports
export var PremiumTrialPaymentForm = `vuzcuEocCTrTW9`;
export var title = `SFKFOAVx5TzdRK`;
export var description = `pci3Xfv_JHx2jD`;
export var disclaimer = `pneW2Kz3W0r2oP`;
export var infoIcon = `Qzl0gP_ruLmaNF`;
export var disclaimerDescription = `uStp1YEsXZIK3C`;
export var cancelButton = `kzlfYv7QCUMtkQ`;
export default ___CSS_LOADER_EXPORT___;
